import React, {useState} from 'react';

import styles from './DeliveryCourier.module.css'
import {Radio} from "../../../../../../ui/Filters/components/Radio/Radio.tsx";
import {Order} from "../../../../../../types/Order.interface.ts";
import {DeliveryCourierAddress} from "./components/DeliveryCourierAddress/DeliveryCourierAddress.tsx";
import {Address, DeliveryType} from "../../../../../../types/Delivery.interface.ts";

interface Props {
    offer: Order,
    onDeliveryAddressChange: (address: Address, isUpdate: boolean , changeBranch: boolean, deliveryType: string|null) => void
}

export const DeliveryCourier: React.FC<Props> = ({onDeliveryAddressChange, offer}) => {
    const scheduleOptions = offer.delivery.time.map(({from, to}) => {
            const value = `C ${from} до ${to}`;

            return {
                label: value,
                value
            };
    });

    const [schedule, setSchedule] = useState<string>(scheduleOptions.length ? scheduleOptions[0].value : '')

    const changeAddress = (address: Address) => {
        onDeliveryAddressChange(address, true, false, DeliveryType.courier);
    }

    return (
        <>
            <div className={styles.address}>
                <DeliveryCourierAddress onCourierAddressChange={changeAddress} />
            </div>
            {
                scheduleOptions.length
                ? <div className={styles.time}>
                    <div className={styles.timeLabel}>
                        Время доставки
                    </div>
                    <Radio
                        options={scheduleOptions}
                        selectedValue={schedule}
                        onChange={(option) => {
                            setSchedule(option)
                        }}
                    />
                </div>
                : null
            }
        </>
    );
};